<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="dm-stage">
        <div
          v-for="(p, i) in pages"
          :key="i"
          class="dm-page"
          :style="{ '--i': i }"
        >
          <span class="dm-bar dm-bar--title"></span>
          <span class="dm-bar dm-bar--md"></span>
          <span class="dm-bar dm-bar--md"></span>
          <span class="dm-bar dm-bar--sm"></span>
          <span class="dm-corner"></span>
        </div>
      </div>
      <div class="dm-foot">
        <span class="dm-pip dm-pip--on"></span>
        <span class="dm-pip"></span>
        <span class="dm-pip"></span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewDocument',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
  data() {
    return { pages: [0, 1, 2] }
  },
})
</script>

<style scoped lang="scss">
.dm-stage {
  position: relative;
  flex: 1;
  display: grid;
  place-items: center;
  min-height: 150px;
}
.dm-page {
  position: absolute;
  width: 110px;
  height: 140px;
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.14);
  border-radius: 4px;
  padding: 14px 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 1px 0 rgba(15, 15, 20, 0.04);
  transform: translate(calc(var(--i) * 8px - 8px), calc(var(--i) * -2px));
  z-index: calc(3 - var(--i));
}
.dm-corner {
  position: absolute;
  top: 0;
  right: 0;
  width: 14px;
  height: 14px;
  background: linear-gradient(225deg, rgba(15, 15, 20, 0.08) 50%, transparent 50%);
  border-bottom-left-radius: 3px;
}
.dm-bar {
  display: block;
  height: 5px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.dm-bar--title {
  height: 7px;
  width: 70%;
  background: rgba(15, 15, 20, 0.22);
  margin-bottom: 2px;
}
.dm-bar--md { width: 90%; }
.dm-bar--sm { width: 60%; }
.dm-foot {
  display: flex;
  justify-content: center;
  gap: 6px;
}
.dm-pip {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.15);
}
.dm-pip--on { background: var(--accent); }
</style>
